import { AppStorageKeys } from "../../Constants/Constants";
import SessionStorage from "../../Constants/SessionStorage";

import { getCurrentUserFromStore } from "../../Constants/Utilities";
const KcAdminClient = require("@keycloak/keycloak-admin-client").default;

const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);
const AUTH_URL = ENV_VARS.AUTH_URL;
const AUTH_PORT = ENV_VARS.AUTH_PORT;
const MASTER_CLIENTID = ENV_VARS.MASTER_CLIENTID;
export const SettingService = {
  resetPassword,
};

const changePassword = async (
  kcAdminClient,
  username,
  userrealm,
  newpassword
) => {
  kcAdminClient.realmName = userrealm;
  const realmusers = await kcAdminClient.users.find();
  const userforpasswordreset = realmusers.filter(
    (user) => user.username === username
  );
  await kcAdminClient.users.resetPassword({
    id: userforpasswordreset[0].id,
    credential: {
      temporary: false,
      type: "password",
      value: newpassword,
    },
  });
};

async function resetPassword(Password, authUrl) {
  const currentUser = getCurrentUserFromStore();
  authUrl = AUTH_URL || authUrl;
  const adminclient = new KcAdminClient({
    baseUrl: `${authUrl}:${AUTH_PORT}/auth`,
    realmName: "master",
  });

  let masteradminclientcliclientid = MASTER_CLIENTID;

  await adminclient.auth({
    grantType: "client_credentials",
    clientId: "admin-cli",
    clientSecret: masteradminclientcliclientid,
  });
  let username = currentUser?.username;
  let partner = currentUser?.partner;
  let newpassword = Password;
  await changePassword(adminclient, username, partner, newpassword);
}
